.Eyebrow {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1.5rem;
  background: rgb(234, 243, 252);
  color: rgb(20, 97, 174);
  font-weight: 600;
  font-size: 15px;
  padding: 4px 14px;
  border-radius: 999px;
}

.Eyebrow img {
  width: 1.75rem;
  height: 1.75rem;
}
